import {
  LandingPageHero,
  LandingPageHeroProps
} from '../../../../components/_external-pages/landing/';

const props: LandingPageHeroProps = {
  title: 'Ser parte de la familia iBAN ',
  titlePrimary: '¡Tiene múltiples beneficios!',
  text: 'Accede a capacitaciones, eventos, comisiones, premios y mucho más.',
  image: '/static/home/hero2.webp',
  overlay: '/static/overlay2.svg',
  buttons: [
    {
      text: 'Conocer más',
      to: '/agentes',
      href: '',
      variant: 'contained',
      size: 'medium',
      color: 'primary'
    },
    {
      text: 'Únete ahora',
      to: '/agentes/register',
      href: '',
      variant: 'contained',
      size: 'medium',
      color: 'inherit'
    }
  ]
};

export const HomeHeroInPage = () => {
  return (
    <>
      <LandingPageHero {...props} />
    </>
  );
};
